export default __webpack_public_path__ + "static/media/vila-model.8f771ada.m4v";